import { createSelector } from 'reselect';

export const getModals = (state) => state.modals;
export const hasOpenModals = createSelector(getModals, (modals) =>
  Object.values(modals).some(Boolean)
);
